import { Redirect } from 'react-router-dom'
import { useEditorState } from '../hooks/useEditorState'

export const EditorNewFormHandler = () => {
  const { uuid } = useEditorState()

  return !uuid ? <>...loading</> : <Redirect to={`/editor/${uuid}`} />
}
